import { render, staticRenderFns } from "./merchant-class-edit.vue?vue&type=template&id=540aab0c"
import script from "./merchant-class-edit.vue?vue&type=script&lang=js"
export * from "./merchant-class-edit.vue?vue&type=script&lang=js"
import style0 from "./merchant-class-edit.vue?vue&type=style&index=0&id=540aab0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports